// extracted by mini-css-extract-plugin
export default {"landing-tabs":"W3czl"};